import type { ClientInstance } from "@stelar/api-sdk";

import { buildClient } from "@stelar/api-sdk";

import { getEnvironmentValues } from "@/config/environment";

const { apiUrl, appVersion } = getEnvironmentValues();

export const client: ClientInstance = buildClient({
  apiUrl,
  xRequestedFor: "web-app",
  xRequestedVersion: appVersion,
  stelarClient: {
    retry: true,
    debug: false,
  },
  inferenceClient: {
    retry: true,
    debug: false,
  },
  s3Client: {
    retry: true,
    debug: false,
  },
});
